import { noTokenHttpClient } from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

const verifyOtpService = async (baseURL, requestBody) => {
  try {
    const verifyOtpRequestObj = {
      applicationId: requestBody?.applicationId,
      otp: requestBody?.otp,
    };
    const verifyOtpResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.verifyOtp}`,
      JSON.stringify(verifyOtpRequestObj)
    );

    if (verifyOtpResponse?.status === 200 && verifyOtpResponse.data) {
      return verifyOtpResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export default verifyOtpService;
